export const ACL_ROUTE = {
  // "/search-rates" IS kept registered for kam — the ocean rate-results
  // page's "Edit Query" button deep-links back here as
  // `/search-rates?_id=<queryId>` to re-adjust an ALREADY-established
  // customer query (see OceanMainRateCom.jsx), not to start an independent
  // blind search. Removing it entirely broke that legitimate flow (blank
  // page on Edit Query). The "don't let a KAM search standalone" rule is
  // instead enforced by hiding the top-nav link (Header.jsx) and, as the
  // real guarantee, requiring an existing query/customerId server-side
  // (saveOceanRateQuery) — so even a hand-typed bare /search-rates URL can't
  // actually complete a search with no customer attached.
  kam: ["/QueriesKAM", "/user-management", "/send-manual-quote", "/send-manual-quote-v2", "/send-manual-quote-ocean", "/booking-view", "/bookingdeletehistory", "/search-rates",
    // Deep-link target (ocean KAM "confirmation awaited" email) — exact leading-slash
    // match required so the PageLayout on-mount guard doesn't bounce it to /QueriesKAM.
    "/booking-history/ocean-cargo-booking-details",
    // Air equivalent: the Queries eye icon on a Booked/Cancelled air row now
    // navigates KAM/admin to this standalone page instead of rendering the
    // detail inline (see handleAirBookingView in pages/Admin/Queries.jsx), so
    // the URL must survive a refresh / be shareable for these roles too.
    "/booking-history/air-booking-details"],
    
  air_admin: ["/dashboard", "/booking-view", "/user-management-admin", "/organization-management", "/kyc-verification", "/accepted-quotation-management", "/rejected-quotation-management", "/rate-management", "/markup-management", "/transportation-rate-management", "/ftl-transportation-rate-management", "/vehicle-type", "/create-key-account-manager", "/archives", "/exchange-rate", "/payment-request", "/QueriesKAM", "/airline_schedule", "/airline-product",
  "/bookingdeletehistory", "/awbmanagement", "/ocean-api-logs", "/carrier-management",
   // KYB Manager (modules/kyb/manager): admins only manage KYB manager accounts
    // ("/kyb-manager-users"); the review console is for kyb_manager / kyb_executive.
    "/kyb-manager-users",
    // Same ocean deep-link target as kam above. air_admin is treated as KAM-side
    // for these booking links (PageLayout's isKamSide, OceanCargoDetails'
    // isKamOrAdmin), and /booking-view is already listed for the air equivalent —
    // without this the on-mount guard bounced an air_admin off the ocean link to
    // /dashboard, so the confirm flow the page implements for them was unreachable.
    "/booking-history/ocean-cargo-booking-details",
    // Air standalone booking-detail page — same reason as the kam entry above.
    "/booking-history/air-booking-details"
  ],

  // Element [0] is the on-refresh fallback: the PageLayout guard sends the user
  // here ONLY when the current URL isn't allowed for their role. It is
  // deliberately NOT "/home" — refreshing an allowed page should keep the user
  // on that page, and a disallowed page should fall back to the app's main
  // screen (/search-rates), not the post-login landing.
  // The post-login landing ("/home") is navigated to explicitly by the login
  // forms (LoginWithEmail/LoginWithOtp both call navigate('/home')); it is
  // served by its own top-level route in App.js (outside PageLayout) and is
  // listed here only to be an allowed destination — not registered in `routs`.
  // KYB manager: only the KYB Manager menu. Element [0] is where login and a
  // disallowed URL send them.
  kyb_manager: ["/kyb-manager"],
  // KYB executive: a member of a KYB manager's team — same console, fewer actions.
  kyb_executive: ["/kyb-manager"],

  customer: [ "/search-rates", "/home", "/bookingdeletehistory", "/queries", "/booking-history", "/user/profile", "/user/kyc", "/user/help-and-support", "/user/settings"
    , "/user/terms-and-conditions", "/user/my-credits", "/user/my-credits/learn-credit-limit", "/booking-history/ocean-cargo-booking-details"
    // Deep-link target (e.g. email link) — must carry a leading slash so it
    // exactly matches useLocation().pathname; otherwise the on-refresh guard
    // in PageLayout bounces it to the fallback route (/search-rates).
    , "/booking-history/air-booking-details"
    // Deep-link targets for the quotation emails' "View Quote" button
    // (`?queryId=<id>`), which now opens the rate-results page directly
    // instead of the Queries list. In-app navigation to these was never
    // affected by the ACL (they're registered as explicit routes in
    // PageLayout, not through getAuthorizedRoutes), but a cold click from an
    // email is a MOUNT — so without them the on-refresh guard above bounces
    // the customer straight back to /search-rates.
    , "/search-rates/ocean-rates-result"
    , "/search-rates/search-rates-result"
    // Business verification (KYB) — customer + customer_admin only; the KYC
    // menu target. /business-verification (App.js) just redirects here.
    , "/user/business-verification"
    , "/credit-invoices"
    //"/trackingDetail"
  ],
  customer_admin: [ "/search-rates", "/home", "/queries", "/booking-history", "/user-management-customer", "/user/profile", "/user/kyc", "/user/help-and-support",
    "/user/settings", "/user/terms-and-conditions", "/user/my-credits", "/user/my-credits/learn-credit-limit", "/credit-invoices","/booking-history/ocean-cargo-booking-details",
    // Deep-link target (email link) — leading slash required (see customer note above).
    "/booking-history/air-booking-details",
    // Quotation-email "View Quote" targets — the ocean quote mail also copies
    // the org's customer_admin, so this role needs them too (see customer).
    "/search-rates/ocean-rates-result",
    "/search-rates/search-rates-result",
    // Business verification (KYB) — see customer note above.
    "/user/business-verification",
    // "/trackingDetail","/subscription-list","/subscription-template","/contact-management",
    ]
}


export const Filter_QUERY = [
  {
    value: 1,
    label: "All",
  },
  {
    value: 2,
    label: "Auto Quoted",
  },
  {
    value: 3,
    label: "Quoted Pending",
  },
  {
    value: 4,
    label: "Booked",
  },
  {
    value: 5,
    label: "Manual Quoted",
  },
];



export const ORIGIN_DESTINATION_CHARGE_TYPE = [
  {
    value: "origin",
    label: "Origin",
  },
  {
    value: "destination",
    label: "Destination",
  },
]

export const UNIT_CHARGE_TYPE = [
  {
    value: "perkg",
    label: "Per CH Kg",
  },
  {
    value: "lmsm",
    label: "Lump Sum",
  },
]

// Air manual quote (multi-airline) charge lines use "perkg"/"lumpsum" to
// match the airlines[].flightOptions[].charges.* API contract — kept
// separate from UNIT_CHARGE_TYPE above since that one's "lmsm" value is
// relied on elsewhere (Ocean manual quote, VAS rates).
export const AIR_CHARGE_UNIT_TYPE = [
  {
    value: "perkg",
    label: "Per CH Kg",
  },
  {
    value: "lumpsum",
    label: "Lump Sum",
  },
]

// ── Ocean Manual Quote (KAM) ────────────────────────────────────────────────
export const OCEAN_RATE_SCOPE = [
  { key: "doorOrigin", label: "Door Origin" },
  { key: "inlandCyOrigin", label: "Inland CY Origin" },
  { key: "cyOrigin", label: "CY Origin" },
  { key: "cyDestination", label: "CY Destination" },
  { key: "inlandCyDestination", label: "Inland CY Destination" },
  { key: "doorDestination", label: "Door Destination" },
];

export const OCEAN_CHARGE_CALC_TYPE = [
  { value: "SubjectTo", label: "SubjectTo" },
  { value: "Fixed", label: "Fixed" },
];

export const OCEAN_CHARGE_BASIS = [
  { value: "Per Container", label: "Per Container" },
  { value: "Per BL", label: "Per BL" },
];

export const OCEAN_CHARGE_CURRENCY = [
  { value: "INR", label: "INR" },
  { value: "USD", label: "USD" },
  { value: "EUR", label: "EUR" },
];

export const OCEAN_LOAD_TYPE = [
  { value: "FCL", label: "FCL" },
];

// Space availability offered on a manually quoted rate (air + ocean). The
// numeric `value` is what the booking flow already carries as
// `space_availability` on an offline rate. Only "Space Available" (1) is
// submitted for now — see the manual-quote payload builders.
export const SPACE_AVAILABILITY_OPTIONS = [
  { value: 1, label: "Space Available" },
  { value: 2, label: "Subject to Availability" },
];

// Cargo type classifications offered in the ocean manual-quote's Commodity
// field. `value` is the full descriptive label itself (not a short code) so
// whatever gets stored on the booking (`cargoDetails.commodity`) is always
// the full name — no separate code -> label lookup needed downstream.
export const OCEAN_CARGO_TYPE_OPTIONS = [
  { value: "Freight All Kinds (FAK)", label: "Freight All Kinds (FAK)" },
  { value: "Hazardous Cargo", label: "Hazardous Cargo" },
  { value: "Non-Hazardous Cargo", label: "Non-Hazardous Cargo" },
  { value: "Chilled Cargo", label: "Chilled Cargo" },
  { value: "Flexibags", label: "Flexibags" },
  { value: "Foodstuff", label: "Foodstuff" },
  { value: "Frozen Cargo", label: "Frozen Cargo" },
  { value: "Others", label: "Others" },
  { value: "Out of Gauge (OOG)", label: "Out of Gauge (OOG)" },
  { value: "Vehicles", label: "Vehicles" },
];

// Back-compat: some bookings were created before OCEAN_CARGO_TYPE_OPTIONS
// stored the full label — they persisted the short code instead (e.g.
// "FAK"). Used to recover the full name for display on those records.
export const OCEAN_CARGO_TYPE_CODE_LABELS = {
  FAK: "Freight All Kinds (FAK)",
  HAZ: "Hazardous Cargo",
  NAC: "Non-Hazardous Cargo",
  CHL: "Chilled Cargo",
  FLX: "Flexibags",
  FDS: "Foodstuff",
  FRZ: "Frozen Cargo",
  OTH: "Others",
  OOG: "Out of Gauge (OOG)",
  VEH: "Vehicles",
};

export const OCEAN_FREE_DAY_KEYS = [
  { key: "detention", label: "Detention" },
  { key: "demurrage", label: "Demurrage" },
  { key: "storage", label: "Storage" },
  { key: "demurrageWithStorage", label: "Demurrage w/ Storage" },
  { key: "combinedDnD", label: "Combined D&D" },
  { key: "combinedDnDWithStorage", label: "Combined D&D w/ Storage" },
];

// Haulage mode is the transport mode moving cargo between door and port —
// not who arranges it (that distinction doesn't apply here).
export const OCEAN_HAULAGE_MODE = [
  { value: "Road", label: "Road" },
  { value: "Rail", label: "Rail" },
  { value: "Barge", label: "Barge" },
];

// Standard ocean service-type combinations (receipt/delivery handling at
// each end) — same 4-value list for pickup and delivery service type.
export const OCEAN_SERVICE_TYPE = [
  { value: "CY/CY", label: "CY/CY" },
  { value: "CY/CFS", label: "CY/CFS" },
  { value: "CFS/CY", label: "CFS/CY" },
  { value: "CFS/CFS", label: "CFS/CFS" },
];

export const OPERATION_TYPE = [
  { value: "PAX", label: "PAX" },
  { value: "FRT", label: "FRT" },
  { value: "TRK", label: "TRK" },
]




export const VAS_RATE_CHARGE_TYPE = [
  {
    value: "kg",
    label: "KG",
  },
  {
    value: "All In",
    label: "All In",
  },
]





export const makePayloadForRateAvailability = (payloadRes = {}, queryId) => {
  // const {
  //   airlineResponse,
  //   expiryTime,
  //   isExpired,
  //   minutesUntilExpiry,
  //   isAllreadyBooked,
  //   manualQuoteId
  // } = payloadRes.nodeData;
  // const  search_query_data = payloadRes?.nodeData?.searchquery;
  // const {    originAirport, destinationAirport  } = search_query_data
  // const {
  //   origin,
  //   destination,
  //   routingPreference,
  //   commodityDetails,
  //   shipmentQuantityDetails,
  //   productDetails,
  // } = search_query_data.airlinepayloadData;
  // const { origincountryName } = originAirport;
  // const { destinationcountryName } = destinationAirport;
  // const appendSearch =  {...payloadRes.nodeData.searchquery,  airlinepayloadData :payloadRes.nodeData.searchquery.search_query_data.airlinepayloadData}
  // const mergeResPonse = {
  //   nodeData: {
  //     queryId ,
  //     manualQuoteId,
  //     expiryTime,
  //     isExpired,
  //     minutesUntilExpiry,
  //     isAllreadyBooked,
  //     status :"New",
  //     searchquery : {
  //       ...appendSearch,
  //       originAirport,
  //       destinationAirport
  //     },
  //     origin,
  //     airlineResponse,
  //     origincountryName,
  //     destinationcountryName,
  //     ...payloadRes,
  //     originAirport,
  //     destinationAirport,
  //     destination,
  //     routingPreference,
  //     commodityDetails,
  //     shipmentQuantityDetails,
  //     productDetails,
  //   },
  // };
  return payloadRes;
};

export const SELECT_DAYS = [
  { id: 1, label: "Sunday", value: "Su" },
  { id: 2, label: "Monday", value: "Mo" },
  { id: 3, label: "Tuesday", value: "Tu" },
  { id: 4, label: "Wednesday", value: "We" },
  { id: 5, label: "Thursday", value: "Th" },
  { id: 6, label: "Friday", value: "Fr" },
  { id: 7, label: "Saturday", value: "Sa" },
];


export const NUMBER_OF_DAYS = [
  { label: 0, value: 0 },
  { label: 1, value: 1 },
  { label: 2, value: 2 },
  { label: 3, value: 3 },
  { label: 4, value: 4 },
  { label: 5, value: 5 },
];

export const QUERIES_CLASS = {
  "Auto Quoted": "autoQuoted",
  "Manual Quoted": "manualquoted",
  "Quote Pending": "quotepending",
  "Booking Confirmed": "bookingconfirmed"
}
//////////////////////////////////////////////////


